import React from "react";
import { ApplicationState } from "./../store";
import { actions } from "./../store/PaymentType";
import { connect, ConnectedProps } from "react-redux";
import { TextInputGroupBase } from "./TextInputGroupBase";
import clsx from "clsx";

export const BankAccountOwnerNameInput: React.FC<BankAccountOwnerNameProps> = (props: BankAccountOwnerNameProps) => {
  const description = props.stateDescriptions[props.state];

  return (
    <TextInputGroupBase
      input={{
        onChange: props.onChange,
        helperText: description,
        placeholderText: props.placeholderText,
        hasError: props.state > 0,
        value: props.value ?? "",
        id: "bankOwnerName",
        inputClass: clsx(props.inputClass),
      }}
      label={{
        title: props.title ?? "",
      }}
      help={{
        title: props.description?.title ?? "",
        description: props.description?.text ?? "",
      }}
    />
  );
};

const connector = connect((state: ApplicationState) => state.payment?.inputs.bankAccountOwnerName, {
  onChange: actions.accountOwnerNameChanged,
});

type BankAccountOwnerNameProps = ConnectedProps<typeof connector> & { inputClass?: string };
export default connector(BankAccountOwnerNameInput);
